import React, { useContext } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// inspired on iOS tab layout from https://mui-treasury.com/styles/tabs/
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";

import AppContext from "../appContext";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))(({ theme }) => ({
  backgroundColor: "#dde1e1",
  borderRadius: theme.shape.borderRadius,
  "& .MuiTabs-indicator": {
    top: 3,
    bottom: 3,
    right: 3,
    left: 3,
    height: "auto",
    background: "none",
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      left: 4,
      right: 4,
      bottom: 0,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.paper,
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.16)",
    },
  },
  /* "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#635ee7",
  } */
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    //fontWeight: theme.typography.fontWeightRegular,
    //fontSize: theme.typography.pxToRem(15),
    zIndex: 1000,
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.text.primary,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);

export default function UserTabs(props) {
  const { t } = useTranslation();
  const path = props.location.pathname;
  const tabs = [
    { label: t("timeline.title"), path: `/timeline` },
    { label: t("moodboards.title"), path: `/moodboards` },
    { label: t("surveys.title"), path: `/surveys` },
  ];
  const {
    dispatch,
    app: { openClientDrawer },
  } = useContext(AppContext); // save last path

  const getIndex = () => {
    const index = tabs.findIndex((tab) => tab.path === path);
    if (index) return index;
    return 0;
  };

  return (
    <Box flexGrow={1}>
      <StyledTabs
        value={getIndex()}
        aria-label="user tabs"
        key={openClientDrawer}
        variant="fullWidth"
      >
        {tabs.map((tab, i) => (
          <StyledTab
            key={"Tab" + tab.label + openClientDrawer}
            label={tab.label}
            component={Link}
            to={{ pathname: tab.path }}
            onClick={() => dispatch({ type: "SET_PATH", payload: tab.path })}
          />
        ))}
      </StyledTabs>
    </Box>
  );
}
